import { css } from '@emotion/react';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

export const commonStyles = css`
  padding-top: ${threeQuartersSpacing}px;
  padding-bottom: ${threeQuartersSpacing}px;
`;
